























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { perRoadStore } from '@/store/store';
import { UnitSystem } from '@/interfaces/units';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import {
  ILayerPerformanceCriteriaImperial,
  ILayerPerformanceCriteriaMetric,
  IPerRoadLayerImperial,
} from '@/modules/perRoad/interfaces/perRoad';
import PrSurfaceDeflectionPlot from '@/modules/perRoad/views/components/criteria/plots/PrSurfaceDeflectionPlot.vue';
import {
  IPrMonteCarloDrawImperial,
  IWesleaConfigBatch,
  IWesleaResultBatch,
} from '@/modules/perRoad/interfaces/monteCarlo';
import { calculateSurfaceDeflectionDistributionFromResults } from '@/modules/perRoad/lib/calculations/surfaceDeflection';


const echarts = require('echarts');

@Component({
  components: {
    PrSurfaceDeflectionPlot,
    PxNumberInput,
  },
})
export default class PrSurfaceDeflection extends Vue {
  @Prop() performanceCriteria!: ILayerPerformanceCriteriaImperial | ILayerPerformanceCriteriaMetric

  @Prop() id!: number;

  @Prop({ default: 0 }) externalKey!: number;

  @Prop() layerImperial!: IPerRoadLayerImperial;

  @Prop() layerNumber!: number;

  @Prop() draws!: IPrMonteCarloDrawImperial[];

  @Prop() wesleaConfigs!: IWesleaConfigBatch;

  @Prop() wesleaResults!: IWesleaResultBatch;

  internalKey = 0;

  get plotKey() {
    console.log('updating key');
    return this.internalKey + this.externalKey;
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    this.$emit('sync');
    this.internalKey += 1;
  }


  get resultDistribution() {
    console.log('Calculating result distribution');

    // It's necessary to perform an operation in this getter that involves this.externalKey
    // in order to trigger recalculation & display after an update from the simulation.
    //
    // Looks like dead code but it's not!
    const necessaryUnusedVariable = this.externalKey;

    const resultDist = calculateSurfaceDeflectionDistributionFromResults(
      this.draws,
      this.wesleaConfigs,
      this.wesleaResults,
      this.layerNumber,
      perRoadStore.displayUnits,
    );
    this.internalKey += 1;
    return resultDist;
    // return null
  }
}
